import {start, createCustomElement} from '@/common-scripts/main-script';
import PostSale from './postsale.vue';

const sessionStorageKey = 'trenitalia-post-sale-config';

if(window.self == window.top && import.meta.env.DEV){
	const urlParams = new URLSearchParams(window.location.search);
	sessionStorage.setItem(sessionStorageKey, JSON.stringify({
		travelId: urlParams.get('travelId')
	}));
}

start(PostSale, {
	configStorageKey: sessionStorageKey,
	elementSelector: '#trenitalia-post-sale'
});

// define a custom element work with shadowDOM
customElements.define('trenitalia-post-sale', createCustomElement(PostSale, {
	configStorageKey: sessionStorageKey
}));